export default {
  bold: 'Bold',
  italic: 'Italic',
  underline: 'Underline',
  list: 'List',
  link: 'Link',
  codeblock: 'Codeblock',
};
